import JoinPageService from "./services/api/join_page";

import jwt_decode from 'jwt-decode';

const tokenName = `jr-token-${process.env.REACT_APP_BASENAME}`;
const tokenTypeName = `jr-token-type-${process.env.REACT_APP_BASENAME}`;

export const setTokenCookie = (token, type) => {
	sessionStorage.setItem(tokenName, token);
	sessionStorage.setItem(tokenTypeName, type);
}

export const removeTokenCookie = (token, type) => {
	sessionStorage.removeItem(tokenName);
	sessionStorage.removeItem(tokenTypeName);
}

export const getNewToken = async() => {
	const response = await JoinPageService.getAuthToken();
	setTokenCookie(response.token, 'public');
	console.log("The public token has been generated");
	return response.token;
}

export const expToken = () => {
	const tokenDateTime = expTokenDate();
	const currentDatetime = Date.now();
	const exp = tokenDateTime ? Math.floor((currentDatetime - tokenDateTime) / (1000*60*60)) > -2 : true;
	return exp;
}

export const expTokenDate = () => {	
	let token = sessionStorage.getItem(tokenName);
	if (token) {
		try {
			let data = jwt_decode(token);
			return data.exp*1000;
		}
		catch {
			return null;
		}
	} 
	return null;
}

export const checkTokenAndUpdate = async () => {
	let token = sessionStorage.getItem(tokenName);
	const tokenDateTime = await expTokenDate();
	const tokenType = sessionStorage.getItem(tokenTypeName);
	
	const currentDatetime = Date.now();
	const exp = tokenDateTime ? Math.floor((currentDatetime - tokenDateTime) / (1000*60*60)) > -2 : true;
	const isGolfer = tokenType === 'golfer';

	if (exp && !isGolfer)  {
		console.log("ok");
		token = await getNewToken();
	}
	
	if (exp && isGolfer) {
		removeTokenCookie();
		const clubPath = window.location.href.split('/').slice(0, 6).join('/');
		window.location.replace(clubPath);
	}
	
	return token;
}
